/**
 * What the scans page is looking at travels in the query string:
 * `?scan=12&climb=48`. So a wall someone is halfway through setting can be
 * pasted to a colleague, and a reload comes back to it rather than to the top
 * of the list.
 *
 * The query string rather than the path — `/scans/12/48` would read better —
 * because a path param means a second `<Route>`, and matching a different route
 * remounts the page. The drafts and the circles being drawn are page state, so
 * remounting on every selection would throw away unsaved work. One route, one
 * mount, the URL as the source of truth: the same trade the route-setting
 * board's filters make.
 */

const SCAN = 'scan';
const CLIMB = 'climb';

export interface ScanSelection {
  scanId: string | null;
  /** The scan colour being worked on — a "bounding box" in the analysis's terms. */
  colorId: string | null;
}

export function readScanSelection(params: URLSearchParams): ScanSelection {
  return {
    scanId: params.get(SCAN)?.trim() || null,
    colorId: params.get(CLIMB)?.trim() || null,
  };
}

/**
 * Open a scan. The climb goes with it: the one that was open belongs to the
 * wall being left, and carrying its id across would name nothing on the new one.
 */
export function scanToParams(scanId: string, current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current);
  next.set(SCAN, scanId);
  next.delete(CLIMB);

  return next;
}

/** Open one of the scan's climbs, or close the one that is open. */
export function climbToParams(colorId: string | null, current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current);
  if (colorId) next.set(CLIMB, colorId);
  else next.delete(CLIMB);

  return next;
}
